<template>
    <div class="min-quantity mt-4">
        <div :class="{
                'input-focus-effect': true,
                'rv-valiadate-input-form': error
            }">
            <input :class="minQuantity !== '' ? 'border-primary' : ''" type="text" id="inputMinQuantity"
                v-model="minQuantity" @focus="e => e.target.select()" inputmode="numeric"/>
            <label :class="{
                    'mb-0': true,
                    'input-on-alue': minQuantity !== ''
                }">{{ $detect == 'mobile' ? 'Số lượng bán ra' : 'Số lượng tối thiểu bán ra'}}</label>
        </div>
        <div class="text-danger fs-12px mt-1" v-if="error">{{error}}</div>
    </div>
</template>
<script>
export default {
    props: ['data', 'error'],
    data() {
        return {
            minQuantity: ''
        }
    },
    watch: {
        data(val){
            this.minQuantity = this.$formatNumber(val);
        },
        minQuantity(val){
            this.$emit('update:data', val);
        }
    },
    created() {
        this.minQuantity = this.$formatNumber(this.data);
    }
}
</script>
